import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LookupService } from '@services/lookup.service';
import { forkJoin, Subject } from 'rxjs';

import { delay, takeUntil } from 'rxjs/operators';
import { Currency } from '@models/currency.model';

import { AdjustmentModalTemplateComponent } from '../../adjustment-modal-template/adjustment-modal-template.component';
import { TestedParty } from '../tested-party.model';
import { Lookup } from '@models/lookup.model';

export const EDIT_TESTED_PARTY_TEXT = 'Edit';
export const ADD_TESTED_PART_TEXT = 'Add';
export const TITLE_TEXT = ' Tested Party';
export const NEW_TESTED_PARTY = ' new';

@Component({
  selector: 'app-adjustment-tested-party',
  templateUrl: './adjustment-tested-party.component.html',
  styleUrls: ['./adjustment-tested-party.component.css'],
})
export class AdjustmentTestedPartyComponent implements OnInit, OnDestroy {
  @ViewChild(AdjustmentModalTemplateComponent, { static: false }) modal: AdjustmentModalTemplateComponent;
  @Input() readOnly = false;
  @Input() testedParty: TestedParty;

  bindDataS = new Subject();

  titleText = ADD_TESTED_PART_TEXT + NEW_TESTED_PARTY + TITLE_TEXT;
  saveButtonText = ADD_TESTED_PART_TEXT;

  currencies: Currency[] = [];
  currencyUnits: Lookup[] = [];

  testedPartyForm: UntypedFormGroup = this.fb.group(
    {
      testedPartyName: ['', Validators.required],
      currency: [null, Validators.required],
      currencyUnits: [null, Validators.required],
      internalNotes: [''],
    },
    { updateOn: 'change' }
  );

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private lookupService: LookupService, private fb: UntypedFormBuilder) {}

  ngOnInit() {
    if (this.testedParty && this.testedParty.adjustmentsTestedPartyId > 0) {
      this.titleText = EDIT_TESTED_PARTY_TEXT + TITLE_TEXT;
      this.saveButtonText = EDIT_TESTED_PARTY_TEXT;
    }

    const currencyUnits$ = this.lookupService.GetCurrencyUnits$();
    const currencies$ = this.lookupService.GetCurrencies$();

    this.bindDataS
      .asObservable()
      .pipe(delay(1), takeUntil(this.destroy$))
      .subscribe(() => this.bindData());

    forkJoin([currencyUnits$, currencies$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([_currencyUnits, _currencies]) => {
        this.currencies = _currencies;
        this.currencyUnits = _currencyUnits;
        this.bindDataS.next('');
      });
  }

  bindData() {
    this.testedPartyForm.patchValue({
      testedPartyName: this.testedParty.testedPartyName,
      currency: this.testedParty.currencyLookup,
      internalNotes: this.testedParty.internalNotes,
      currencyUnits: this.testedParty.currencyUnitLookup ? this.testedParty.currencyUnitLookup.lookupId : null,
    });
  }

  onSubmit() {
    if (this.testedPartyForm.valid) {
      this.testedParty = {
        ...this.testedParty,
        testedPartyName: this.testedPartyForm.value.testedPartyName.trim(),
        currencyId: this.testedPartyForm.value.currency.currencyId,
        internalNotes: this.testedPartyForm.value.internalNotes,
        currencyUnits: this.testedPartyForm.value.currencyUnits.value,
        currencyUnitLookupId: this.testedPartyForm.value.currencyUnits,
      };
      this.close(this.testedParty);
    }
  }

  close(_testedParty: TestedParty = null) {
    this.modal.close(_testedParty);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
